import { is, isNil, not, reduce } from 'ramda'
import { isNotNaN, isFunction, isNilOrEmpty } from 'ramda-adjunct'
import moment from 'moment'
import { LAYOUT_SET_LOADING_MESSAGE, LAYOUT_ADD_ERROR, LAYOUT_REMOVE_ERROR } from '../store/modules/layout'

const isDatepicker = className => className.includes('app-datepicker')

export const processFormSubmit = e => {
  if (isNil(e) || not(is(Function, e.preventDefault))) {
    throw new Error('Form submit event is not valid.')
  }

  e.preventDefault()

  const formValues = reduce((acc, element) => {
    const { name, value, type, checked = false, className } = element

    if (name) {
      const apiValue = isNilOrEmpty(value) ? null : value

      if (name.startsWith('transObj')) {
        const nameSliced = name.split('-')
        acc[nameSliced[1]] = acc[nameSliced[1]] || {}
        acc[nameSliced[1]][nameSliced[2]] = apiValue
      } else if (name.endsWith('[]')) {
        if (checked) {
          const nameSliced = name.slice(0, -2)
          acc[nameSliced] = acc[nameSliced] || []
          acc[nameSliced].push(apiValue)
        }
      } else {
        if (type === 'checkbox') {
          acc[name] = checked
        } else if (type === 'radio') {
          if (checked) {
            if (name.endsWith('Id')) {
              const parsedValue = parseInt(apiValue, 10)
              acc[name] = isNotNaN(parsedValue) ? parsedValue : apiValue
            } else {
              acc[name] = apiValue
            }
          }
        } else if (name.startsWith('hour') || name.startsWith('minute')) {
          acc[name] = apiValue
        } else if (type === 'number' || type === 'select-one') {
          const parsedValue = parseInt(apiValue, 10)
          acc[name] = isNotNaN(parsedValue) ? parsedValue : apiValue
        } else if (isDatepicker(className) && apiValue) {
          acc[name] = moment.utc(apiValue, 'DD. MM. YYYY').toISOString()
        } else {
          acc[name] = apiValue
        }
      }
    }

    return acc
  }, {}, e.target.elements)

  return formValues
}

const CREATE = 'create'
const UPDATE = 'update'

export const getCommonFormSubmit = apiMethodSuffix => async (vm, e, optionalData = {}) => {
  const formData = processFormSubmit(e)
  let promise

  if (vm.newItem) {
    promise = vm[CREATE + apiMethodSuffix]({
      data: {
        ...formData,
        ...optionalData
      }
    })
  } else {
    if (isNil(vm.itemId)) {
      throw new Error(`vm.itemId is ${typeof vm.itemId}. Set this value to allow entity updates.`)
    }

    promise = vm[UPDATE + apiMethodSuffix]({
      params: {
        id: vm.itemId,
        code: vm.code || null
      },
      data: {
        ...formData,
        ...optionalData
      }
    })
  }

  const result = await promise
  if (vm.backAllowed) {
    if (!isFunction(vm.goBack)) {
      throw new Error('Method goBack not found. Set this method to allow "Save and go back" functionality')
    }

    vm.goBack()
  }

  return result
}

let errorTimeoutId
export const showErrorWithTimeout = (vm, error) => {
  const ref = { type: 'error', text: error }
  setError(vm, ref)
  clearTimeout(errorTimeoutId)
  errorTimeoutId = setTimeout(() => {
    vm.$store.commit({
      type: LAYOUT_REMOVE_ERROR,
      error: ref
    })
  }, 5000)
}

export const setError = (vm, ref) => {
  vm.$store.commit({
    type: LAYOUT_ADD_ERROR,
    error: ref
  })
}

export const setLoadingMessage = (vm, message) => {
  vm.$store.commit({
    type: LAYOUT_SET_LOADING_MESSAGE,
    message
  })
}
